import React, { useEffect, useState } from "react";
import {
	IonInput,
	IonItem,
	IonLabel,
	IonSelect,
	IonSelectOption,
	IonButtons,
	IonContent,
	IonHeader,
	IonMenuButton,
	IonPage,
	IonTitle,
	IonToolbar,
	IonCol,
	IonGrid,
	IonRow,
	IonIcon,
	IonButton,
	IonText,
	useIonAlert,
	IonCard,
	IonCardContent,
	IonCardHeader,
	IonCardSubtitle,
	IonCardTitle
} from "@ionic/react";
import axios from "axios";
import {
	calendar,
	call,
	createOutline,
	mail,
	pencil,
	pencilOutline,
	phoneLandscape,
	phonePortrait,
	trash
} from "ionicons/icons";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useStore from "../../store/store";
import AnimatedPage from "../AnimatedPage";
import { Phone } from "../../controls";

const TenantDetails: React.FC = (props: any) => {
	const { t } = useTranslation();
	const history = useHistory();
	const [presentAlert] = useIonAlert();
	const { setIsLoading, token } = useStore((state: any) => state);

	const [elem, setElem] = useState<{
		_id: string;
		name: string;
		email: string;
		phone: string;
		joined: string;
	}>({
		_id: "",
		name: "",
		email: "",
		phone: "",
		joined: ""
	});

	useEffect(() => {
		const id = props.match.params.tenantId;
		if (id) {
			axios
				.get(`${process.env.REACT_APP_API_URL}/tenants/${id}`, {
					headers: { rentapp_auth: token }
				})
				.then(res => {
					setElem(res.data);
				})
				.catch(err => console.log(err));
		}
	}, []);

	const handleEdit = (id: any) => history.push(`/tenant/u/${id}`);

	const handleDelete = (id: any) => {
		axios
			.delete(`${process.env.REACT_APP_API_URL}/tenants/${id}`, {
				headers: { rentapp_auth: token }
			})
			.then(res => {
				history.push("/tenants");
			})
			.catch(err => console.log(err));
	};

	return (
		<IonPage>
			<AnimatedPage>
				<IonHeader>
					<IonToolbar>
						<IonButtons slot="start">
							<IonMenuButton />
						</IonButtons>
						<IonTitle>{t("tenants")}</IonTitle>
					</IonToolbar>
				</IonHeader>

				<IonContent fullscreen>
					<IonHeader collapse="condense">
						<IonToolbar>
							<IonTitle size="large">{t("tenants")}</IonTitle>
						</IonToolbar>
					</IonHeader>
					<IonGrid>
						<IonRow>
							<IonCol size="12">
								<IonCard>
									<IonCardHeader>
										<IonCardTitle
											style={{
												fontSize: 25,
												fontWeight: "bold"
											}}
										>
											{elem?.name}
										</IonCardTitle>
										<IonCardSubtitle>
											<IonIcon icon={mail}></IonIcon>{" "}
											{elem.email}
											<br />
											<IonIcon icon={call}></IonIcon>{" "}
											<Phone
												displayType="text"
												value={elem?.phone}
											/>
											<br />
											<IonIcon
												icon={calendar}
											></IonIcon>{" "}
											{moment(elem.joined).format(
												"DD-MMM-YYYY"
											)}
											<br />
										</IonCardSubtitle>
									</IonCardHeader>
									<IonCardContent style={{ float: "right" }}>
										<IonButton
											onClick={() =>
												handleEdit(elem?._id)
											}
										>
											<IonIcon icon={pencil}></IonIcon>
											{t("edit")}
										</IonButton>
										<IonButton
											onClick={() =>
												presentAlert({
													header: `${t("sureToDel")}`,
													buttons: [
														{
															text: `${t(
																"cancel"
															)}`,
															role: "cancel"
														},
														{
															text: `${t("yes")}`,
															role: "confirm",
															handler: () => {
																handleDelete(
																	elem._id
																);
															}
														}
													]
												})
											}
										>
											<IonIcon
												className="trash"
												icon={trash}
											></IonIcon>{" "}
											{t("delete")}
										</IonButton>
									</IonCardContent>
								</IonCard>
							</IonCol>
						</IonRow>
					</IonGrid>
				</IonContent>
			</AnimatedPage>
		</IonPage>
	);
};

export default TenantDetails;
